import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=022ffe59&scoped=true&"
import script from "./Block.vue?vue&type=script&lang=js&"
export * from "./Block.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Block.vue?vue&type=style&index=0&id=022ffe59&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "022ffe59",
  null
  ,true
)

export default component.exports